import axios from "axios";

import variables from "@/global/variables";
import session from "@/global/session";

/*
 * Admin client for auction-close.php. The admin secret is sent in the
 * X-Admin-Secret header. GET previews the winning bids without changing state;
 * POST freezes bidding and returns the same winners list.
 */

export interface AuctionWinner {
	itemNumber: number;
	name: string | null;
	bidNumber: number;
	amount: number;
}

export interface ChargeCounts {
	created: number;
	existed: number;
	errored: number;
}

export interface CloseResult {
	closed: boolean;
	winners: AuctionWinner[];
	charges?: ChargeCounts;
}

// Authorize with the logged-in admin's session token; the server verifies the
// attendee's "Admin" role. A ?secret= route param may still pass the shared
// secret as a fallback (server-to-server / debugging).
function authHeaders(routeSecret?: string): { [key: string]: string } {
	const headers: { [key: string]: string } = {};
	const token = session.token();
	if (token) headers["X-Bidder-Token"] = token;
	if (routeSecret) headers["X-Admin-Secret"] = routeSecret;
	return headers;
}

export default class AuctionCloseModel {
	static async winners(routeSecret?: string): Promise<AuctionWinner[]> {
		const response = await axios.get(variables.apiEndpoint + "/auction-close.php", {
			headers: authHeaders(routeSecret),
		});
		return (response.data as CloseResult).winners;
	}

	static async close(routeSecret?: string): Promise<CloseResult> {
		const response = await axios.post(variables.apiEndpoint + "/auction-close.php", {}, { headers: authHeaders(routeSecret) });
		return response.data as CloseResult;
	}
}
